import axios from "../../axiosConfig";

const normalizeContextRole = (value) =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

const normalizeUsers = (payload) => {
  const users = Array.isArray(payload) ? payload : payload?.users;
  return Array.isArray(users) ? users : [];
};

export const getOrganizationContextRole = (user) => {
  const contextRole = normalizeContextRole(user?.context_role);
  if (contextRole === "admin") return "admin";
  if (contextRole === "user") return "user";
  return "user";
};

export const getOrganizationUsers = async (organizationId) => {
  const response = await axios.get(`/organizations/${organizationId}/users`);
  return normalizeUsers(response.data);
};

export const updateOrganizationUserRole = async (organizationId, userId, contextRole) => {
  return axios.patch(`/organizations/${organizationId}/users/${userId}/role`, {
    context_role: contextRole,
  });
};

export const createOrganizationUser = async (organizationId, payload) => {
  return axios.post(`/organizations/${organizationId}/users`, payload);
};

export const updateOrganizationUser = async (userId, payload) => {
  return axios.put(`/users/${userId}`, {
    user: {
      first_name: payload.first_name,
      last_name: payload.last_name,
      email: payload.email,
    },
  });
};

export const deleteOrganizationUser = async (organizationId, userId) => {
  return axios.delete(`/organizations/${organizationId}/users/${userId}`);
};
